import { useEffect, useState } from "react";
import { hasPermission } from "../helpers/common";
import { getPermissionsList } from "../helpers/getPermission";

type PropsType = {
  label: string;
  handleClick: () => void;
  permission?: string;
};

const DownloadButton = ({ label, handleClick, permission }: PropsType) => {
  const [permissionList, setPermissionList] = useState([]);
  const _getPermissions = async () => {
    let token = await getPermissionsList();
    setPermissionList(token?.permissions);
  };
  useEffect(() => {
    _getPermissions();
  }, []);

  return (
    <div className="tsk-btn floating-btn-comp">
      <button
        className={`d-flex ${
          !hasPermission(permissionList, [permission]) &&
          "bg-opacity-25 bg-success"
        }`}
        type="button"
        disabled={!hasPermission(permissionList, [permission])}
        onClick={handleClick}
      >
        <span className="material-icons-round">download</span>
        <p>{label}</p>
      </button>
    </div>
  );
};

export default DownloadButton;
